import React from "react";
import { TableDetail } from "./tableDetail";
class TableDetailParent extends React.Component {
    render() {
        return (
            <TableDetail {...this.props} />
        )
    }
}
export default TableDetailParent